/**
 * Class strings for the website's controls, applied to the shadcn primitives at
 * the call site (components/ui is generated and never hand-edited).
 */

/** Page-ground fill on a surface card, hairline border, 10px radius, 44px tall. */
export const inputClass =
  'h-11 rounded-[10px] bg-background px-3.5 text-ui md:text-ui dark:bg-background'

/**
 * With `inputClass`, makes a Select trigger match the inputs beside it. Its own
 * height is set on `data-size`, which outranks a plain `h-11`.
 */
export const selectTriggerClass = 'w-full data-[size=default]:h-11 pr-3'

/** The primary action: 9px radius, lifts 1px and brightens on hover. */
export const primaryActionClass =
  'h-11 rounded-[9px] px-[22px] text-ui font-semibold transition-[translate,filter,background-color] hover:bg-primary hover:brightness-110 motion-safe:hover:-translate-y-px'

/** The ghost button: surface fill and a 1.4px line border. */
export const ghostActionClass =
  'h-11 rounded-[9px] border-[1.4px] border-border bg-card px-[22px] text-ui font-semibold hover:bg-tint dark:border-border dark:bg-card dark:hover:bg-tint'

/** On a painted hero or scene: white fill, ink text. */
export const onDarkActionClass =
  'h-11 rounded-[9px] bg-white px-[22px] text-ui font-semibold text-ink transition-[translate,filter] hover:bg-white hover:brightness-95 motion-safe:hover:-translate-y-px'

/** An inline text link. */
export const linkClass = 'font-semibold text-link underline-offset-[3px] hover:underline'
